/** Cooldown clock for the resend-code button. Pure over an injected `nowMs`
 * so it unit-tests without timers or a DOM; the flow ticks it with Date.now()
 * on a setInterval and toggles the button. */

export interface ResendCooldown {
  start(nowMs: number): void;
  remaining(nowMs: number): number;
  ready(nowMs: number): boolean;
}

export function createResendCooldown(seconds: number): ResendCooldown {
  let endMs = 0;
  return {
    start(nowMs) {
      endMs = nowMs + seconds * 1000;
    },
    remaining(nowMs) {
      return Math.max(0, Math.ceil((endMs - nowMs) / 1000));
    },
    ready(nowMs) {
      return nowMs >= endMs;
    },
  };
}
